import type { ChangeEvent, PropsWithChildren } from 'preact/compat';
import './Radio.less';

export type RadioProps = PropsWithChildren<{
    id: string;
    name: string;
    className?: string;
    onChange?: (event: ChangeEvent, state: boolean) => void;
    checked: boolean;
}>;

const Radio = ({
    id,
    name,
    className = '',
    children = '',
    onChange,
    checked
}: RadioProps) => (
    <label className={`bri-Radio bri-Body2Font ${className}`}>
        <input
            id={id}
            name={name}
            type="radio"
            checked={checked}
            onChange={event => onChange?.(event, !checked)}
        />
        {typeof children === 'string' && children !== '' && (
            <span>{children}</span>
        )}
        {typeof children !== 'string' && children}
    </label>
);

export default Radio;
